import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Button, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { imageURL } from "Config/endpoints";
import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { toast } from "react-toastify";
import { deleteMainHeaderFn, searchMainHeaderFn } from 'Services/Header';
import AddCustomiseHeaderForm from './AddCustomiseHeaderForm';

const MainHeader = () => {
  const [toggleAddCustomizationHeader, setToggleAddCustomizationHeader] = useState(false);
  const [ids, setIds] = useState(null);
  const [editHeader, setEditHeader] = useState(null);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  const { mutate: deleteMainHeader } = useMutation(deleteMainHeaderFn, {
    onSuccess: (response) => {
      if (response?.status === 200) {
        toast.success(response?.data?.message);
      }
      refetchMainHeader();
    }
  })

  const { data: searchMainHeaderResponse, refetch: refetchMainHeader } = useQuery(
    ['search-header', search, page],
    () => searchMainHeaderFn({ search, page }),
    {
      keepPreviousData: true,
    }
  )

  const handleToggleAddCustomizationHeader = () => {
    setToggleAddCustomizationHeader(prev => {
      if (prev === true) {
        setEditHeader(null);
        return false;
      } else {
        return true;
      }
    });
  }


  const handleChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (searchMainHeaderResponse?.data) {
      setTotalPage(searchMainHeaderResponse.data.total_pages || 1);
    }
  }, [searchMainHeaderResponse]);

  useEffect(() => {
    refetchMainHeader();
  }, [page, search, refetchMainHeader]);

  const mainHeader = searchMainHeaderResponse?.data?.data || [];

  return (
    <div className="!bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Manage Customization Main Header List
          </p>
        </div>
        <div className="p-2 pt-5">
          <Button variant="outlined" color="primary" onClick={handleToggleAddCustomizationHeader}>
            <AddIcon />
            Add Customization Main Header
          </Button>
        </div>
        <AddCustomiseHeaderForm
          open={toggleAddCustomizationHeader}
          handleClose={handleToggleAddCustomizationHeader}
          ids={ids}
          setIds={setIds}
          header={editHeader}
          refetchMainHeader={refetchMainHeader}
        />
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex gap-3">
            <input
              className="placeholder:italic placeholder:text-slate-400 block mx-3 bg-white w-80 border border-slate-300 rounded-md py-2 px-2 pr-3 shadow-sm focus:outline-none focus:border-slate-600 focus:ring-slate-500 focus:ring-1 sm:text-sm"
              placeholder="Search for anything..."
              type="text"
              name="search"
              value={search}
              onChange={(event) => setSearch(event.target.value)}
            />
          </span>
        </div>
        <TableContainer
          component={Paper}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  TITLE
                </TableCell>
                <TableCell
                  style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  Business Type
                </TableCell>
                <TableCell
                  style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  Seller
                </TableCell>
                <TableCell
                  style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  URL
                </TableCell>
                <TableCell
                  style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  IMAGE
                </TableCell>
                <TableCell
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {searchMainHeaderResponse?.data?.data?.data.map((row, index) => (
                <TableRow key={row?.id} className="!text-slate-700">
                  <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                    {row?.title || "--"}
                  </TableCell>
                  <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                    {row?.business_type_name || "--"}
                  </TableCell>
                  <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                    {row?.seller_name || "--"}
                  </TableCell>
                  <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                    {row?.url || "--"}
                  </TableCell>
                  <TableCell className="!text-center !text-[12px]" style={{ borderRight: "1px solid #D0D0D0", fontFamily: "'Poppins', sans-serif" }}>
                    {row?.image ? (
                      <img src={imageURL(row?.image)} className="h-8 mx-auto w-8" alt="header" />
                    ) : (
                      "--"
                    )}
                  </TableCell>
                  <TableCell className="!text-center !text-[12px]" style={{ fontFamily: "'Poppins', sans-serif" }}>
                    <DeleteIcon
                      className="!text-xl !text-red-600 !cursor-pointer"
                      onClick={() => deleteMainHeader({ mainheader_id: row?.id })}
                    />
                    <button onClick={() => { setEditHeader(row); handleToggleAddCustomizationHeader(); }}>
                      <EditIcon className="!text-xl !cursor-pointer !text-green-600" />
                    </button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div className="flex justify-center p-2">
          <Pagination
            page={page}
            size="small"
            count={totalPage}
            variant="outlined"
            color="primary"
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  )
}

export default MainHeader;
